import * as React from 'react';
import { Box, TextInput, Group, Button, NumberInput, Select, Textarea, } from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import { IconChevronDown } from "@tabler/icons-react";
import { sectionTypes } from "./constants";
import type { ISection, ICategory } from "./types";
import SearchableSelect from "../../components/common/SearchableSelect";
import Page from "../../components/layout/Page";
import { IPlaylist } from "../playlist/types";
import { assignFiles } from "../../utils/form";

interface FormValues extends Pick<ISection, 'code' | 'title' | 'description' | 'type' | 'order' | 'itemId'> {
    cover: File | null;
}

interface IParams extends Omit<FormValues, 'cover'> {
    cover?: string;
}

const CreateSection = () => {

    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            code: '',
            title: '',
            description: '',
            cover: null,
            type: 'category',
            itemId: '',
            order: 0,
        },

        validate: {
            code: isNotEmpty('Код оруулна уу'),
            title: isNotEmpty('Нэр оруулна уу'),
            type: isNotEmpty('Төрөл сонгоно уу'),
            itemId: isNotEmpty('Холбох item сонгоно уу'),
        },
    });

    React.useEffect(() => {
        form.setFieldValue('itemId', '');
    }, [form.values.type]);

    const categoryParser = (category: ICategory) => {
        return {
            value: category._id,
            label: category.title,
        }
    }

    const playlistParser = (playlist: IPlaylist) => {
        return {
            value: playlist._id,
            label: playlist.title,
        }
    }

    const handleSubmit = async (values: FormValues) => {
        const files = await assignFiles({
            cover: values.cover
        }, 'section')
        const params: IParams = {
            ...values,
            ...files
        }
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, params);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)}>
                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Код"
                            placeholder="Код оруулна уу"
                            {...form.getInputProps('code')}
                        />

                        <TextInput
                            withAsterisk
                            label="Нэр"
                            placeholder="Нэр оруулна уу"
                            {...form.getInputProps('title')}
                        />

                        <Textarea
                            label="Тайлбар"
                            placeholder="Тайлбар оруулна уу"
                            {...form.getInputProps('description')}
                        />

                        <Select
                            withAsterisk
                            label="Төрөл"
                            rightSection={<IconChevronDown size={14} />}
                            rightSectionWidth={30}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={sectionTypes}
                            {...form.getInputProps('type')}
                        />

                        {
                            form.values.type === 'category'
                            ?   <SearchableSelect<ICategory>
                                    uri={'/api/category/search'}
                                    parser={categoryParser}
                                    selectProps={{
                                        withAsterisk: true,
                                        label: 'Холбосон сэдэв',
                                        ...form.getInputProps('itemId')
                                    }}
                                />
                            :   form.values.type === 'playlist'
                            ?    <SearchableSelect<IPlaylist>
                                    uri={'/api/playlist/search'}
                                    parser={playlistParser}
                                    selectProps={{
                                        withAsterisk: true,
                                        label: 'Playlist',
                                        ...form.getInputProps('itemId')
                                    }}
                                />
                            :   <TextInput
                                    withAsterisk
                                    label='Холбосон бүлгийн дугаар'
                                    placeholder='Холбосон бүлгийн дугаар'
                                    {...form.getInputProps('itemId')}
                                />
                        }

                        <NumberInput
                            label="Дараалал"
                            placeholder="Дараалал оруулна уу"
                            {...form.getInputProps('order')}
                        />

                        <Group position="right" mt="md">
                            <Button type="submit" color='color-secondary'>Хадгалах</Button>
                        </Group>
                    </form>
                </Box>
            </Page.Body>
        </Page>
    );
};

export default CreateSection;